import { schema } from 'normalizr'

const event = new schema.Entity('event')
const eventsArray = [event]

export default eventsArray



// WEBPACK FOOTER //
// ./src/schemas/events.js